/**
 * Binance C2C REST API
 *
 * OpenAPI Specification for the Binance C2C REST API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ConfigurationRestAPI, RestApiResponse, sendRequest } from '@binance/common';
import { C2CApi } from './modules/c2-capi';

import type { GetC2CTradeHistoryRequest } from './modules/c2-capi';

import type { GetC2CTradeHistoryResponse } from './types';

export class RestAPI {
    private configuration: ConfigurationRestAPI;
    private c2CApi: C2CApi;

    constructor(configuration: ConfigurationRestAPI) {
        this.configuration = configuration;
        this.c2CApi = new C2CApi(configuration);
    }

    /**
     * Generic function to send a request.
     * @param endpoint - The API endpoint to call.
     * @param method - HTTP method to use (GET, POST, DELETE, etc.).
     * @param queryParams - Query parameters for the request.
     * @param bodyParams - Body parameters for the request.
     *
     * @returns A promise resolving to the response data object.
     */
    sendRequest<T>(
        endpoint: string,
        method: 'GET' | 'POST' | 'DELETE' | 'PUT' | 'PATCH',
        queryParams: Record<string, unknown> = {},
        bodyParams: Record<string, unknown> = {}
    ): Promise<RestApiResponse<T>> {
        return sendRequest<T>(
            this.configuration,
            endpoint,
            method,
            queryParams,
            bodyParams,
            undefined
        );
    }

    /**
     * Generic function to send a signed request.
     * @param endpoint - The API endpoint to call.
     * @param method - HTTP method to use (GET, POST, DELETE, etc.).
     * @param queryParams - Query parameters for the request.
     * @param bodyParams - Body parameters for the request.
     *
     * @returns A promise resolving to the response data object.
     */
    sendSignedRequest<T>(
        endpoint: string,
        method: 'GET' | 'POST' | 'DELETE' | 'PUT' | 'PATCH',
        queryParams: Record<string, unknown> = {},
        bodyParams: Record<string, unknown> = {}
    ): Promise<RestApiResponse<T>> {
        return sendRequest<T>(
            this.configuration,
            endpoint,
            method,
            queryParams,
            bodyParams,
            undefined,
            { isSigned: true }
        );
    }

    /**
     * Get C2C Trade History
     *
     * The max interval between startTimestamp and endTimestamp is 30 days.
     * If startTimestamp and endTimestamp are not sent, the recent 30 days' data will be returned.
     * You can only view data from the past 6 months. To see all C2C orders, please check https://c2c.binance.com/en/fiatOrder
     *
     * Weight: 1
     *
     * @summary Get C2C Trade History (USER_DATA)
     * @param {GetC2CTradeHistoryRequest} requestParameters Request parameters.
     *
     * @returns {Promise<RestApiResponse<GetC2CTradeHistoryResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @see {@link https://developers.binance.com/docs/c2c/rest-api/Get-C2C-Trade-History Binance API Documentation}
     */
    getC2CTradeHistory(
        requestParameters: GetC2CTradeHistoryRequest = {}
    ): Promise<RestApiResponse<GetC2CTradeHistoryResponse>> {
        return this.c2CApi.getC2CTradeHistory(requestParameters);
    }
}
